const nb = {
  lead: "Familier, turgåere, skiløpere og turister følger trollene til fots, på ski og med båt. Sett troll ved døra di, så leder jakten nye gjester rett til deg — uansett hva slags sted du driver.",
  areasKicker: "Bransjer",
  areasTitle: "Finn din bransje.",
  bannerKicker: "Har du en bedrift i denne bransjen?",
  bannerTitle: "Få flere kunder. Tiltrekk nye besøkende.",
  cta: "Bli partner med Trollfossjakten",
  placesLike: "Steder som",
  ideaTitle: "Trollidé",
  cats: {
    hotels: {
      name: "Hoteller og hotellkjeder",
      short: "Gjør trolljegere til overnattingsgjester.",
      lead: "Et troll ved inngangen, i hagen eller på hotellets egen sti gir familier en grunn til å bli over natta — og komme tilbake neste sesong.",
      idea: "Et bærertroll som bærer bagasjen ved døra, et frokosttroll ved buffetvinduet og et natttroll under nordlyset på takterrassen.",
      types: ["Hotellkjeder", "Historiske hoteller", "Fjord- og fjellhoteller", "Resorter og spahoteller", "Kysthoteller", "Hytter og lodger"],
    },
    restaurants: {
      name: "Restauranter og kafékjeder",
      short: "Sultne jegere, rett utenfor døra.",
      lead: "Trolljakt gjør folk sultne. Plasser troll ved restaurantene deres, og la spillerne forhåndsbestille og betale med Vipps på veien.",
      idea: "Et kokketroll som rører i suppa, et pizzatroll på terrassen og et kaffetroll som vokter den beste vindusplassen.",
      types: ["Pizza- og burgerkjeder", "Kaffekjeder", "Steakhouses", "Familierestauranter", "Sushi og asiatisk", "Bakerikjeder"],
    },
    activities: {
      name: "Aktiviteter og opplevelser",
      short: "Gi eventyrerne enda en grunn til å booke.",
      lead: "Fjordturer, rafting, safari og guidede turer er perfekt trollterreng. Trollene deres gjør en tur til et oppdrag — og leder spillerne til bookingdisken.",
      idea: "Et redningsvesttroll ved kajakkbrygga, et bretroll på isen og et nordlystroll som bare viser seg på vintersafari.",
      types: ["Fjordturer og cruise", "Kystreiser", "Rafting og kajakk", "Arktisk safari og nordlys", "Eventyrreiser", "Villmarkssentre"],
    },
    ski: {
      name: "Skisentre og fjelldestinasjoner",
      short: "Troll i bakken, hele vinteren.",
      lead: "Troll ved heisene, i langrennssporet og på toppkafeen gjør hver skidag til en jakt — og får familiene tilbake om sommeren også.",
      idea: "Et skitroll på gamle treski ved heisen, et snøtroll i skogsløypa og et topptroll som serverer varm kakao.",
      types: ["Alpinsentre", "Langrennssentre", "Fjellbygder", "Sommerski", "Afterski og lodger", "Skiskoler"],
    },
    attractions: {
      name: "Attraksjoner og museer",
      short: "La trollene fortelle historien deres.",
      lead: "Troll hører hjemme i norsk folketro. Sett dem i museumsparken, ved stavkirka eller langs den kjente turen, så blir de besøkende lenger og utforsker mer.",
      idea: "Et fortellertroll ved det gamle tunet, et dragehodetroll på stavkirka og et stupetroll som vokter utsiktspunktet.",
      types: ["Friluftsmuseer", "Skips- og historiemuseer", "Kunstmuseer", "Stavkirker og katedraler", "Nasjonalparker", "Kjente turer og utsiktspunkt"],
    },
    transport: {
      name: "Transport og ferger",
      short: "Gjør reisen til en del av jakten.",
      lead: "Ferger, hurtigbåter, busser og tog frakter tusenvis av nysgjerrige reisende. Troll om bord og på kaia gjør ventetid til lekestund.",
      idea: "Et sjøtroll som vinker ved baugen, et billettroll på busstoppet og et tunneltroll du bare møter på toget.",
      types: ["Fergeselskap", "Hurtigbåter", "Regionbusser", "Tog", "Bytrafikk", "Kaier og terminaler"],
    },
    cafes: {
      name: "Kafeer og bakerier",
      short: "Ferske boller, varm kaffe — og et troll ved døra.",
      lead: "Ett troll utenfor kafeen din lokker spillerne inn på kaffe, vafler og kanelboller. De kan forhåndsbestille med Vipps og hente når de kommer.",
      idea: "Et bakertroll med mel på nesa som snuser på kanelbollene gjennom vinduet.",
      types: ["Lokale kafeer", "Bakerier", "Kaffebrennerier", "Bakeri- og kaffefilialer", "Iskiosker", "Vaffelbuer"],
    },
    saunas: {
      name: "Badstuer",
      short: "Varm deg opp etter jakten.",
      lead: "Etter en kald dag i løypa slår ingenting en badstue ved fjorden. Et badstutroll leder spillerne til døra di, og de kan booke tid med Vipps.",
      idea: "Et blidt troll i stripete håndkle som damper på dekket og utfordrer alle til å hoppe i fjorden.",
      types: ["Lokale badstuer", "Flytende badstuer", "Fjordbadstuer", "Badstuforeninger", "Spa og badehus", "Badestamper"],
    },
    shops: {
      name: "Små butikker og lokale produsenter",
      short: "Liten butikk, stor oppdagelse.",
      lead: "Trolljegere elsker å ta med seg noe hjem. Ett troll ved butikken din setter deg på kartet for alle som kjører forbi.",
      idea: "Et kjøpmannstroll med en kurv full av syltetøy, ost og ullsokker.",
      types: ["Gårdsbutikker", "Suvenir- og husflidsbutikker", "Bryggerier og destillerier", "Fiske- og friluftsbutikker", "Bokhandler og gavebutikker", "Dagligvare, sport og jernvare"],
    },
  },
};

export default nb;
